import { configureStore } from "@reduxjs/toolkit";

import alertSlice from "./reducers/alertSlice"

const store = configureStore({
    reducer: {

        alert: alertSlice,
    },
});

export default store;